export interface IConta {
  ContaNo: number;
  FranquiaNo: number;
  ContaNome: string;
}
